import { render, staticRenderFns } from "./dashboard-total.vue?vue&type=template&id=2cb1c21d&scoped=true&"
import script from "./dashboard-total.vue?vue&type=script&lang=js&"
export * from "./dashboard-total.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-total.vue?vue&type=style&index=0&id=2cb1c21d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb1c21d",
  null
  
)

export default component.exports